/* * @Author: ligai  */
let project = window.fe.project
const projectMap = {
  'supplier-home': 'supplier/supplier-home'
}
let urlPre = projectMap[project] || project

const rulePreMap = {
  'supplier-home': 'supplier'
}
let rulePre = rulePreMap[project] || project

const currency = {
  // 采购商获取币种列表
  currencyQueryList: {
    url: '/purchaser/currency/query',
    type: 'post'
  },
  // 获取币种列表
  currencyList: {
    url: `${urlPre}/currency/list`,
    type: 'post'
  },
  // 获取本位币
  currencyBase: {
    url: `${urlPre}/currency/base`,
    type: 'get'
  },
  // 获取汇率
  currencyRate: {
    url: `${urlPre}/currency/getExchangeRate`,
    type: 'post'
  },
  // 获取本位币单价
  currencyBaseCurrencyPrice: {
    url: `${urlPre}/currency/exchangeBaseCurrencyPrice`,
    type: 'post'
  },
  // 规则配置
  getListByRuleKey: {
    type: 'post',
    url: project === 'mall' ? '/mall/nologin/rule/listByRuleKey' : `${rulePre}/rule/execute/listByRuleKey`
  }
}
export default currency
